import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import PaymentConstants from 'pages/admin/payment/constants';
import {
    IListPaymentsSearchForm,
    IPayment,
    IPaymentState,
} from 'types/payment';
import numeral from 'plugins/numeral';

const initialState: IPaymentState = {
    payments: [],
    payment: null,
    paymentsSearchForm: {
        searchKeyWord: '',
        status: [PaymentConstants.status.ALL],
        startDate: '',
        endDate: '',
    },
    surveyPayment: {
        product_type: null,
        product_id: null,
        client_id: null,
        client_name: '',
        package: 'Plan',
        upgradeService: 'standard',
        month: 'month',
        campaign: { label: '', value: '' },
        payment_target: {
            dob: [],
            gender: [],
            address: [],
            marriage: [],
            child: [],
            career: [],
            career_field: [],
            monthly_personal_income: [],
            monthly_family_income: [],
        },
        invoiceInfo: {
            companyName: '',
            taxCode: '',
            address: '',
            invoiceRecipient: '',
            phone: '',
            email: '',
        },
        costInfo: {
            total_price: 0,
            number_of_question: 0,
            number_of_answer: 10,
            base_price: 0,
            discount: 0,
            tax: 0,
            total_price_text: '',
            base_price_text: '',
            price_before_discount_text: '',
            discount_text: '',
            price_before_tax_text: '',
            tax_text: '',
            date_payment: '',
            product_overlap_discount: 0,
            product_overlap_discount_text: '',
        },
    },
};

const COST_INFO_FORMAT = '0,0';

const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        setPayments: (state, action: PayloadAction<IPayment[]>) => {
            state.payments = action.payload;
        },
        setPaymentSearchForm: (
            state,
            action: PayloadAction<IListPaymentsSearchForm>
        ) => {
            state.paymentsSearchForm = {
                ...state.paymentsSearchForm,
                ...action.payload,
            };
        },
        clearPaymentSearchForm: (state) => {
            state.paymentsSearchForm = initialState.paymentsSearchForm;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setSurveyPaymentSelectObject: (state, action: PayloadAction<any>) => {
            state.surveyPayment.payment_target = action.payload;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setSurveyPaymentInvoiceInfo: (state, action: PayloadAction<any>) => {
            state.surveyPayment.invoiceInfo = action.payload;
        },
        resetSurveyPayment: (state) => {
            state.surveyPayment = initialState.surveyPayment;
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setCostInfo: (state, action: PayloadAction<any>) => {
            console.log(action.payload);
            state.surveyPayment.costInfo = action.payload;
            const {
                base_price,
                number_of_question,
                number_of_answer,
                discount,
                tax,
                total_price,
                product_overlap_discount,
            } = action.payload;
            let priceBeforeDiscount = 0;
            if (state.surveyPayment.product_type === 'Survey') {
                priceBeforeDiscount =
                    base_price * number_of_question * number_of_answer;
            } else {
                priceBeforeDiscount = base_price;
            }

            let priceBeforeTax = 0;
            if (state.surveyPayment.product_type === 'Survey') {
                priceBeforeTax = priceBeforeDiscount - discount;
            } else {
                priceBeforeTax =
                    priceBeforeDiscount - discount - product_overlap_discount;
            }

            const taxAmount = tax;
            state.surveyPayment.costInfo.total_price_text =
                numeral(total_price).format(COST_INFO_FORMAT);
            state.surveyPayment.costInfo.base_price_text =
                numeral(base_price).format(COST_INFO_FORMAT);
            state.surveyPayment.costInfo.price_before_discount_text =
                numeral(priceBeforeDiscount).format(COST_INFO_FORMAT);
            state.surveyPayment.costInfo.discount_text =
                numeral(discount).format(COST_INFO_FORMAT);
            state.surveyPayment.costInfo.price_before_tax_text =
                numeral(priceBeforeTax).format(COST_INFO_FORMAT);
            state.surveyPayment.costInfo.tax_text =
                numeral(taxAmount).format(COST_INFO_FORMAT);
            state.surveyPayment.costInfo.product_overlap_discount_text =
                numeral(action.payload.product_overlap_discount).format(
                    COST_INFO_FORMAT
                );
        },

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setPaymentProduct: (state, action: PayloadAction<any>) => {
            console.log(action.payload);
            state.surveyPayment.product_type = action.payload.product_type;
            state.surveyPayment.product_id = action.payload.product_id;
            state.surveyPayment.client_id = action.payload.client_id;
            state.surveyPayment.client_name = action.payload.client_name;
            state.surveyPayment.package = action.payload.package;
            state.surveyPayment.upgradeService = action.payload.upgradeService;
            state.surveyPayment.month = action.payload.month;
            state.surveyPayment.campaign = action.payload.campaign;
        },
    },
});

export const {
    setPayments,
    setPaymentSearchForm,
    clearPaymentSearchForm,
    setSurveyPaymentSelectObject,
    setSurveyPaymentInvoiceInfo,
    resetSurveyPayment,
    setCostInfo,
    setPaymentProduct,
} = paymentSlice.actions;

export default paymentSlice.reducer;
